<template>
  <page>
    <v-card>
      <v-card-text>
        <v-form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="docForm.acctNo"
                  :label="labels.acctNo"
                  :error-messages="errors.collect('acctNo')"
                  data-vv-name="acctNo"
                  :data-vv-as="labels.acctNo"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('acctNo')"
                  v-validate="'required'"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="docForm.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-dialog v-model="filterList" width="1000px" persistent>
          <acctmaster-helplist
            v-if="acctMasterList"
            :apiURI="menu.getAcctMasterPage"
            @select="doAssign($event)"
            @close="doClose"
          ></acctmaster-helplist>
        </v-dialog>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import AcctmasterHelplist from '../AcctMasterHelplist'

export default {
  data() {
    return {
      labels: {
        acctNo: 'Account Number',
        export: 'Export To',
        format: 'Export Format'
      },
      docForm: {
        branch: null,
        tranType: null,
        docNo: null,
        acctNo: null,
        fund: null,
        acctNoSfx: null,
        format: 'PDF'
      },
      menu: {},
      supportedFormat: [],
      filterList: false,
      submitting: false,
      acctMasterList: false
    }
  },
  computed: {
    acctMenu() {
      return this.$store.state.reports.acctReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.docForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.acctReports.init !== 1) {
          await this.$store.dispatch('acctReportsInit')
        }
        const apiURI = this.acctMenu.acctCrNote
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList() {
      this.filterList = true
      this.acctMasterList = true
    },
    doAssign(data) {
      this.docForm.branch = data.branch
      this.docForm.tranType = data.tranType
      this.docForm.docNo = data.docNo
      this.docForm.acctNo = data.acctNo
      this.docForm.fund = data.fund
      this.docForm.acctNoSfx = data.acctNoSfx
      this.filterList = false
    },
    doClose() {
      this.filterList = false
      setTimeout(() => {
        this.acctMasterList = false
      }, 200)
    },
    doExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const apiURI = this.menu.export
          this.submitting = true
          if (apiURI) {
            this.$http
              .post(apiURI, this.docForm)
              .then((result) => {
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        }
      })
    }
  },
  async created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    AcctmasterHelplist
  }
}
</script>
